export const enAccountsLocale = {
  // Child Profile Creation
  create_profile_title: 'Create Child Profile',
  create_profile_description:
    'Please provide information about the child who will be using $t(main:app_name). This information is used to personalize the app experience and track lesson progress.',
  create_profile_button: 'Create Profile',

  // Child Profile Thank You
  create_profile_thank_you_title: 'Thank You!',
  create_profile_thank_you_description:
    'Now please give your device to {{name}} and tap "Begin Your Reading Journey" to continue.',
  create_profile_begin_journey: 'Begin Your Reading Journey',

  // Child Profile Fields
  field_child_name: "Child's First Name",
  field_child_name_placeholder: 'Enter name...',
  field_child_name_required: 'Name is required',
  field_child_name_max_length: 'Name must be less than 50 characters',

  field_child_age: 'Child Age',
  field_child_age_placeholder: 'Enter age...',
  field_child_age_min: 'Age cannot be negative',
  field_child_age_max: 'Age must be 12 or under',
  field_child_age_prefer_not_to_say: 'Prefer not to say',

  create_profile_failed:
    'Unable to create child profile. Please try again or contact support@learnwith.ai if the problem persists.',

  create_profile_success: 'Child profile created successfully',

  field_child_incorrect_help_threshold: 'Incorrect Help Threshold',
  field_child_incorrect_help_threshold_placeholder: 'Enter threshold...',
  field_child_incorrect_help_threshold_hint: 'Prompt to skip a step after incorrect answers',
  field_child_incorrect_help_threshold_min: 'Incorrect help threshold must be at least 1',
  field_child_incorrect_help_threshold_max: 'Incorrect help threshold must be 10 or less',

  begin_journey: 'Begin Your Reading Journey',
  default_profile_name: 'Child',

  years_old_one: '{{count}} year old',
  years_old_other: '{{count}} years old',

  // Account Management
  account_title: 'Account Info',

  field_name: 'Name',
  field_name_hint: '',
  field_name_placeholder: 'Enter name...',

  field_email: 'Email',
  field_email_hint: 'To change your email, please contact support@learnwith.ai',
  field_email_placeholder: 'Enter email...',

  field_password: 'Password',
  field_password_placeholder: 'Enter password...',

  field_current_password: 'Current Password',
  field_current_password_hint: '',
  field_current_password_placeholder: 'Enter current password...',

  field_new_password: 'New Password',
  field_new_password_hint: '',
  field_new_password_placeholder: 'Enter new password...',

  field_confirm_password: 'Confirm Password',
  field_confirm_password_hint: '',
  field_confirm_password_placeholder: 'Confirm password...',
  field_confirm_password_mismatch_error: 'Passwords do not match',

  change_password_button: 'Change Password',
  change_password_drawer_title: 'Change Password',

  update_parent_account_failed:
    'Unable to update parent account. Please try again or contact support@learnwith.ai if the problem persists.',
  update_parent_account_success: 'Parent account updated successfully',

  parent_account_title: 'Parent Info',
  update_parent_account_submit_button: 'Save',

  change_password_submit_button: 'Save',
  change_password_success: 'Password changed successfully',
  change_password_failed:
    'Unable to change password. Please try again or contact support@learnwith.ai if the problem persists.',
  change_password_incorrect_password: 'Incorrect password',

  child_account_title: 'Child Info',
  update_profile_button: 'Save',

  update_profile_failed:
    'Unable to update child profile. Please try again or contact support@learnwith.ai if the problem persists.',
  update_profile_success: 'Child profile updated successfully',

  app_settings_title: 'App Settings',
  update_app_settings_button: 'Save',

  update_app_settings_failed:
    'Unable to update app settings. Please try again or contact support@learnwith.ai if the problem persists.',
  update_app_settings_success: 'App Settings updated successfully',

  sign_out_button: 'Sign Out',
  delete_account_button: 'Delete Account',
  delete_account_drawer_title: 'Delete Account',
  delete_account_drawer_content: 'Are you sure you want to delete your account?',
  delete_account_cancel_button: 'Cancel',
  delete_account_confirm_button: 'Delete Account',

  delete_parent_account_failed:
    'Unable to delete parent account. Please try again or contact support@learnwith.ai if the problem persists.',
  delete_parent_account_success: 'Parent account deleted successfully',
};
